<template>
    <va-create-layout>
        <FinancialEventGroup-form
            :title="title"
            :item="item"
        ></FinancialEventGroup-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
